import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const CloseStrategyConfirmDialog = ({
  open,
  onClose,
  fundLabel,
  strategyLabel,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, fontSize: "16px" }}>
       Close Positions
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Are you sure you want to close all positions for {fundLabel} - {strategyLabel}?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Close Positions
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseStrategyConfirmDialog;
